/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import StickyToolsView from "components/stickyTools/StickyToolsView";
import {
  getStickyToolVerbs,
  getStickyToolVerbsDetails,
  getIsStickyToolPanelVisible,
  getStickyToolsAddOnPanel
} from "selectors/stickyToolsSelectors";
import { getShouldRenderPersonalCommentsDropin, getShouldRenderCommentsDropin } from "selectors/overlayDropinSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  ...ownProps,
  stickyToolVerbs: getStickyToolVerbs(stores),
  stickyVerbDetails: getStickyToolVerbsDetails(stores),
  setStickyToolsLoaded: value => stores.documentStore.setStickyToolsLoaded(value),
  shouldRenderCommentsDropin: getShouldRenderCommentsDropin(stores),
  shouldRenderPersonalCommentsDropin: getShouldRenderPersonalCommentsDropin(stores),
  isStickyToolPanelVisible: getIsStickyToolPanelVisible(stores),
  StickyToolsAddOnPanel: getStickyToolsAddOnPanel(stores)
});

const StickyToolsContainer = inject(mapStoreToProps)(StickyToolsView);

export default StickyToolsContainer;
